import React from 'react'
import PropTypes from 'prop-types'
import BaseTemplate from 'components/templates/BaseTemplate'
import StickyBasicContent from 'components/organisms/StickyBasicContent'
import Typography from 'components/atoms/Typography'
import Paper from 'components/atoms/Paper'
import Faq from 'components/atoms/Faq'
import KoinworksBar from 'components/organisms/KoinworksBar'
import { Breadcrumb } from 'reactstrap'
import { Container, Row, Col, Image, BreadcrumbItem } from 'components/qstrap'
import triggerEvent from 'utils/dataLayer'

const WhyKoinworks = ({
  icon,
  title,
  subtitle,
}) => (
  <Col md="3">
    <Image src={`/assets/img/koinworks/${icon}.png`} />
    <Typography variant="headline" component="h3">{title}</Typography>
    <Typography variant="subheadline">{subtitle}</Typography>
  </Col>
)

WhyKoinworks.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
}

const KoinworksStepBox = ({
  step,
  title,
  desc,
}) => (
  <Col className="KoinworksStepBox">
    <div className="step-dot hidden-md-down" />
    <Paper className="p-t-lg">
      <div className="step-icon">
        <Image src={`/assets/img/koinworks/${step}.svg`} />
      </div>
      <small className="font-bolder">Tahap {step}.</small>
      <Typography component="h3" variant="subheading">
        {title}
      </Typography>
      <small>
        {desc}
      </small>
    </Paper>
  </Col>
)

KoinworksStepBox.propTypes = {
  step: PropTypes.number,
  title: PropTypes.string,
  desc: PropTypes.string,
}

const Koinworks = () => (
  <BaseTemplate
    firstSection="#k-banner"
    stickyBottomContent={
      <StickyBasicContent
        title="Pilih Universitas impian, bayar biaya dengan cicilan"
        buttonVariant="orange"
        href="https://forms.gle/L6Md7JMe5xqCexSGA"
        buttonText="Ajukan Sekarang"
      />
    }
    useStickyBottom
    noBreadcrumb
  >
    <div id="Koinworks">
      <Container id="k-banner">
        <a
          href="https://koinworks.com/id/pinjaman/dana-pendidikan?formal_show=true"
          onClick={() => triggerEvent('ga/koinworks/bigbanner')}
        >
          <Image src="/assets/img/koinworks/banner.png" />
        </a>
      </Container>

      <Container>
        <Breadcrumb>
          <BreadcrumbItem tag="a" href="/">
            Quipper Campus
          </BreadcrumbItem>
          <BreadcrumbItem tag="b">
            <b>Koinworks</b>
          </BreadcrumbItem>
        </Breadcrumb>
      </Container>

      <Container>
        <div>
          <Typography variant="title" component="h2">
            Apa Itu KoinWorks?
          </Typography>
          <Typography component="p">
            KoinWorks adalah perusahaan Fintech Lending Indonesia yang melayani investasi online P2P Lending dengan machine learning inovatif, yang menghubungkan Pendana dengan Peminjam dalam sebuah platform teknologi mutakhir. KoinWorks telah terdaftar dan diawasi Otoritas Jasa Keuangan (OJK) ..
            <a href="https://koinworks.com" target="_blank" rel="noopener noreferrer">selengkapnya</a>
          </Typography>
        </div>

        <hr className="k-hr" />

        <div>
          <Typography variant="title" component="h2">
            Tentang KoinPintar
          </Typography>
          <Typography component="p">
            KoinPintar merupakan produk pinjaman pendidikan dari KoinWorks yang semakin memudahkan Anda untuk mendapatkan akses pembiayaan pendidikan yang lebih terjangkau, demi terwujudnya Indonesia Pintar.
          </Typography>
        </div>

        <div id="k-why">
          <Typography variant="title" component="h2">
            Mengapa KoinPintar
          </Typography>
          <Row>
            <WhyKoinworks
              icon="why-1"
              title="Lama Pembiayaan"
              subtitle="3 - 24 Bulan"
            />
            <WhyKoinworks
              icon="why-2"
              title="Cepat & Mudah"
              subtitle="Pengajuan Online"
            />
            <WhyKoinworks
              icon="why-3"
              title="Tanpa Jaminan"
            />
            <WhyKoinworks
              icon="why-4"
              title="Pelunasan Awal"
              subtitle="Tidak dikenakan biaya"
            />
          </Row>
          <div className="p-y-lg m-y-lg">
            <small>
              * Setiap siswa bisa mendapatkan pembiayaan sampai lulus dari KoinPintar dengan catatan setiap periode pendidikan atau semester
              <br />
              perkuliahan, siswa tersebut dapat mengajukan pinjaman kembali di KoinPintar.
            </small>
          </div>
        </div>
      </Container>

      <div id="k-step">
        <Container>
          <Typography variant="title" component="h2">
            Proses Pengajuan Pinjaman
          </Typography>
          <hr className="hidden-md-down" />
          <Row>
            <KoinworksStepBox
              step={1}
              title="Informasi Pendidikan & Biayanya"
              desc="Lengkapi detail tentang kebutuhan pendidikan Anda berikut rincian biayanya dan tentukan jumlah, tenor, & bunganya."
            />
            <KoinworksStepBox
              step={2}
              title="Lengkapi Dokumen"
              desc="Informasi lebih lanjut terkait dokumen yang dibutuhkan bisa dilihat di bawah ini."
            />
            <KoinworksStepBox
              step={3}
              title="Proses Peninjauan oleh Tim KoinWorks"
              desc="Apabila dokumen Anda sudah lengkap, pengajuan Anda akan ditindaklanjuti maksimal 3 hari."
            />
            <KoinworksStepBox
              step={4}
              title="Pinjaman Anda Disetujui"
              desc="KoinWorks akan mencairkan pinjaman langsung ke institusi pendidikan terkait."
            />
            <KoinworksStepBox
              step={5}
              title="Geluti Pendidikan Pilihan, Cicil Biayanya"
              desc="Selamat menempuh pendidikan dan memperluas kesempatan berkarier dengan tenang."
            />
          </Row>
        </Container>
      </div>

      <div id="k-criteria" className="bg-white">
        <Typography variant="title" component="h2">
          Kriteria
        </Typography>

        <Container>
          <Row className="text-center">
            <Col md="4">
              <div><Image src="/assets/img/koinworks/wni.svg" /></div>
              <div>Warga Negara Indonesia.</div>
            </Col>
            <Col md="4">
              <div><Image src="/assets/img/koinworks/calonsiswa.svg" /></div>
              <div>KoinPintar tersedia bagi calon siswa yang bahkan belum terdaftar di institusi pendidikan pilihannya.</div>
            </Col>
            <Col md="4">
              <div><Image src="/assets/img/koinworks/toga.svg" /></div>
              <div>Bisa diajukan untuk pendidikan D3, S1, S2, S3, atau pendidikan informal lainnya.</div>
            </Col>
          </Row>
        </Container>
      </div>

      <div id="k-prepare" className="p-b-lg">
        <Typography variant="title" component="h2">
          Yang Perlu Dipersiapkan
        </Typography>

        <Container>
          <Row>
            <Col md="6">
              <Paper>Mutasi rekening 3 bulan terakhir ***</Paper>
              <Paper>KTP *</Paper>
              <Paper>KTP Pasangan <i>(bila sudah menikah)</i></Paper>
              <Paper>Kartu Keluarga **</Paper>
            </Col>

            <Col md="6">
              <Paper>NPWP **</Paper>
              <Paper>Slip Gaji Borrower</Paper>
              <Paper>Slip Gaji Penanggung <i>(optional)</i></Paper>
            </Col>
          </Row>

          <p className="m-t-lg text-left">
            * KTP harus berupa foto asli atau hasil scan<br />
            ** KK dan NPWP harus berupa foto atau hasil scan<br />
            *** Mutasi Rekening 3 bulan terakhir dapat berupa:<br />
            a. e-statement<br />
            b. Print transaksi buku tabungan dan halaman bagian depan (bukan gabungan transaksi umum)<br />
          </p>
        </Container>
      </div>

      <div id="k-faq" className="bg-white p-b-lg">
        <Typography variant="title" component="h2">
          FAQ
        </Typography>

        <Container className="text-left">
          <Faq question="Apa saja syarat untuk mengajukan pinjaman pendidikan lewat KoinPintar?">
            Syaratnya cukup mudah, yakni WNI, siswa/mahasiswa yang sudah diterima atau belum
            diterima di institusi pendidikan tertentu juga boleh mengajukan pinjaman pendidikan
            terlebih dahulu di KoinPintar. Selain siswa/mahasiswa, semua orang yang ingin mengikuti
            kursus atau sertifikasi tertentu di berbagai bidang juga diperbolehkan untuk mengajukan
            pinjaman pendidikan lewat KoinPintar.
          </Faq>

          <Faq question="Pinjaman pendidikan untuk memenuhi biaya apa saja yang bisa saya ajukan di KoinPintar?">
            Anda bisa mengajukan pinjaman pendiidkan untuk memenuhi seluruh biaya pendidikan yang memang
            dibutuhkan seperti biaya semester, peralatan keterampilan, biaya gedung dan lain sebagainya
            dengan catatan bahwa dana pinjamannya akan langsung ditransfer ke institusi terkait.
          </Faq>

          <Faq question="Untuk mulai mengajukan, dokumen apa yang diperlukan?">
            <p>
              Dokumen yang diperlukan baik bagi pendaftar tanpa wali penjamin ataupun pendaftar dengan wali
              penjamin antara lain:
            </p>
            <ul>
              <li>KTP berwarna</li>
              <li>Kartu Keluarga (fotokopi diperbolehkan)</li>
              <li>Mutasi rekening 3 bulan terakhir harus tercermin pendapatannya (link https://koinworks.com/id/education-center/borrower-mutasi)</li>
              <li>NPWP (apabila pengajuan pinjaman di atas Rp 50 juta)</li>
              <li>Bukti terdaftar di institusi pendidikan terkait</li>
            </ul>
            Apabila pendaftar merupakan siswa/mahasiswa yang berusia di bawah 21 tahun harus menyertakan dokumen wali penjamin.
          </Faq>

          <Faq question="Berapa lama prosesnya?">
            Setelah melengkapi seluruh dokumen yang diperlukan, pihak KoinWorks akan menginformasikan
            hasil penilaian kelayakan kredit dalam waktu 3 hari kerja.
          </Faq>

          <Faq question="Bagaimana dengan rincian bunga dan biaya pinjamannya?">
            Bunga yang dikenakan mulai dari 0.75% sd 1.25% flat per bulan, biaya originasi sebesar 2-4%
            dan biaya administrasi sebesar Rp 100.000 akan ditambahkan ke nominal pokok pinjaman
            atau bisa juga dilunasi dengan cara menyicilnya.
          </Faq>
        </Container>
      </div>

      <KoinworksBar gaPrefix="koinworks" />
    </div>
  </BaseTemplate>
)

export default Koinworks
